<template>
	<li
		class="products__categories-item"
		:class="[
			modifier && `products__categories-item--${modifier}`,
			{
				'products__categories-item--active': active,
			}
		]"
	>
		<a
			class="products__categories-item-link"
			:class="[
				modifier && `products__categories-item-link--${modifier}`,
				{
					'products__categories-item-link--active': active,
				}
			]"
			@click.prevent="$emit('click')"
		>
			<div class="products__categories-item-inner">
				<component
					v-if="iconComponent(category.svgIconKey)"
					:is="iconComponent(category.svgIconKey)"
					class="products__categories-item-icon"
					:class="[
						modifier && `products__categories-item-icon--${modifier}`,
					]"
				/>
				<img
					v-else-if="category.image"
					:src="category.image"
					class="products__categories-item-icon"
					:class="[
						modifier && `products__categories-item-icon--${modifier}`,
					]"
				/>
				<SVGInfo
					v-else
					class="products__categories-item-icon"
					:class="[
						modifier && `products__categories-item-icon--${modifier}`,
					]"
				/>
				<span
					class="products__categories-item-text"
					:class="[
						modifier && `products__categories-item-text--${modifier}`,
					]"
					v-html="category.name"
				/>
			</div>
		</a>
	</li>
</template>

<script>
export default {
	props: {
		category: Object,
		active: Boolean,
		modifier: String,
	},
}
</script>

<style>

</style>